import Vue from 'vue'
import Vuetify from 'vuetify'
import theme from '@/themes'

Vue.use(Vuetify, theme)
